export default __webpack_public_path__ + "static/media/photo_driss.4bb87b27.jpg";